// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.padding-cvv {
  padding-top: 5px;
}

.cvv-image {
  filter: invert(100%);
}

.scan-card-item {
  border: 1px solid rgb(211, 211, 211);
  margin-top: 5px;
  border-radius: 4px;
}
.scan-card-item img {
  width: 35px;
}

.scan-btn {
  background: transparent;
  display: flex;
  column-gap: 10px;
  align-items: center;
  color: #000;
  flex: 1;
}
.scan-btn ion-icon {
  color: #000;
  font-size: 35px;
}
.scan-btn .button-text-position {
  display: flex;
  flex-direction: column;
  text-align: left;
  row-gap: 5px;
}
.scan-btn span {
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cashier/deposit/deposit-creditcard/deposit-creditcard.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EAEE,oBAAA;AACF;;AAEA;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;AACJ;;AAGA;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;AAAF;AAEE;EACE,WAAA;EACA,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AADJ;AAII;EACE,eAAA;AAFN","sourcesContent":[".padding-cvv{\n    padding-top: 5px;\n}\n\n.cvv-image {\n  -webkit-filter: invert(100%);\n  filter: invert(100%);\n}\n\n.scan-card-item {\n  border: 1px solid rgba(211, 211, 211, 1);\n  margin-top: 5px;\n  border-radius: 4px;\n  // display: flex;\n  img {\n    width: 35px;\n  }\n}\n\n.scan-btn {\n  background: transparent;\n  display: flex;\n  column-gap: 10px;\n  align-items: center;\n  color: #000;\n  flex: 1;\n\n  ion-icon {\n    color: #000;\n    font-size: 35px;\n  }\n\n  .button-text-position {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    row-gap: 5px;\n  }\n\n    span {\n      font-size: 15px;\n    }\n    }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
